const setSearchAnimationColourToMatchTheme = (theme) => {
  // NOTE: This function makes use of while loops to prevent DOM-query related race conditions
  const colour = theme?.palette?.primary?.main || 'black';
  const animationPane = document.querySelector('lottie-player');
  if (animationPane?.shadowRoot) {
    const magnifierCircleSvgPath =
      'path[d=" M41.01599884033203,-32.500499725' +
      '3418 C47.096004486083984,-32.5004997253418 52.032501220703125,-27.5640' +
      '06805419922 52.032501220703125,-21.483999252319336 C52.032501220703125' +
      ',-15.403992652893066 47.096004486083984,-10.467498779296875 41.0159988' +
      '4033203,-10.467498779296875 C34.93599319458008,-10.467498779296875 29.' +
      '99949836730957,-15.403992652893066 29.99949836730957,-21.4839992523193' +
      '36 C29.99949836730957,-27.564006805419922 34.93599319458008,-32.500499' +
      '7253418 41.01599884033203,-32.5004997253418z"]';
    const magnifierCircleAndLense = animationPane.shadowRoot.querySelectorAll(
      magnifierCircleSvgPath
    );
    while (
      typeof magnifierCircleAndLense === 'object' && // It is a NodeList, which, despite of its enumerable nature, is not an array
      magnifierCircleAndLense.length === 2 &&
      magnifierCircleAndLense[1]?.getAttribute('stroke') !== colour
    ) {
      magnifierCircleAndLense[1]?.setAttribute('stroke', colour);
    }
    const magnifierShaftSvgPath =
      'path[d=" M47.90999984741211,-14.5900001525' +
      '8789 C47.90999984741211,-14.59000015258789 54.80400085449219,-7.695000' +
      '171661377 54.80400085449219,-7.695000171661377"]';
    const magnifierShaftNodeList = animationPane.shadowRoot.querySelectorAll(
      magnifierShaftSvgPath
    );
    while (
      typeof magnifierShaftNodeList === 'object' && // It is a NodeList, which, despite of its enumerable nature, is not an array
      magnifierShaftNodeList[0]?.getAttribute('stroke') !== colour
    ) {
      magnifierShaftNodeList[0]?.setAttribute('stroke', colour);
    }
    const magnifierHandleSvgPath =
      'path[d=" M54.49300003051758,-11.607999801' +
      '635742 C55.27199935913086,-12.378999710083008 56.527000427246094,-12.378' +
      '000259399414 57.305999755859375,-11.607000350952148 C57.305999755859375,' +
      '-11.607000350952148 64.56300354003906,-4.421999931335449 64.563003540039' +
      '06,-4.421999931335449 C65.35299682617188,-3.6389999389648438 65.35299682' +
      '617188,-2.361999988555908 64.56199645996094,-1.5789999961853027 C64.5619' +
      '9645996094,-1.5789999961853027 61.005001068115234,1.937999963760376 61.0' +
      '05001068115234,1.937999963760376 C60.22600173950195,2.7090001106262207 5' +
      '8.97100067138672,2.7090001106262207 58.19200134277344,1.937999963760376 ' +
      'C58.19200134277344,1.937999963760376 50.935001373291016,-5.2480001449584' +
      '96 50.935001373291016,-5.248000144958496 C50.14500045776367,-6.031000137' +
      '329102 50.14500045776367,-7.308000087738037 50.93600082397461,-8.0909996' +
      '03271484 C50.93600082397461,-8.090999603271484 54.49300003051758,-11.607' +
      '999801635742 54.49300003051758,-11.607999801635742z"]';
    const magnifierHandleNodeList = animationPane.shadowRoot.querySelectorAll(
      magnifierHandleSvgPath
    );
    while (
      typeof magnifierHandleNodeList === 'object' && // It is a NodeList, which, despite of its enumerable nature, is not an array
      (magnifierHandleNodeList[0]?.getAttribute('stroke') !== colour ||
        magnifierHandleNodeList[0]?.getAttribute('fill') !== colour)
    ) {
      magnifierHandleNodeList[0]?.setAttribute('stroke', colour);
      magnifierHandleNodeList[0]?.setAttribute('fill', colour);
    }

    // Enable visibility of the animation
    animationPane.setAttribute('style', 'opacity: 1');
  }
};

const setSuccessAnimationColourToMatchTheme = (theme) => {
  const colour = theme?.palette?.primary?.main || 'black';
  const circlePath =
    'path[d=" M346.6669921875,0 C346.6669921875,191.45799255371094 191.45899963378906,346.6669921875 0,346.6669921875 C-191.45799255371094,346.6669921875 -346.6669921875,191.45799255371094 -346.6669921875,0 C-346.6669921875,-191.45899963378906 -191.45799255371094,-346.6659851074219 0,-346.6659851074219 C191.45899963378906,-346.6659851074219 346.6669921875,-191.45899963378906 346.6669921875,0z"]';
  const animationPane = document.querySelector('lottie-player');

  if (animationPane?.shadowRoot) {
    const circlePathNodeList =
      animationPane.shadowRoot.querySelectorAll(circlePath);
    while (
      typeof circlePathNodeList === 'object' &&
      circlePathNodeList[0] &&
      circlePathNodeList[0]?.getAttribute('fill') !== colour
    ) {
      circlePathNodeList[0]?.setAttribute('fill', colour);
      circlePathNodeList[1]?.setAttribute('fill', colour);
      circlePathNodeList[2]?.setAttribute('fill', colour);
    }
  }
};

const setStandardAnimationColourToMatchTheme = (theme) => {
  const colour = theme?.palette?.primary?.main || 'black';
  const circlePath = 'path[stroke="rgb(24,144,255)"]';
  const animationPane = document.querySelector('lottie-player');

  if (animationPane?.shadowRoot) {
    const circlePathNodeList =
      animationPane.shadowRoot.querySelectorAll(circlePath);
    while (
      typeof circlePathNodeList === 'object' &&
      circlePathNodeList[0] &&
      circlePathNodeList[0]?.getAttribute('stroke') !== colour
    ) {
      circlePathNodeList[0]?.setAttribute('stroke', colour);
    }
  }

  // Enable visibility of the animation
  animationPane.setAttribute('style', 'opacity: 1');
};

// eslint-disable-next-line import/prefer-default-export
export {
  setSearchAnimationColourToMatchTheme,
  setSuccessAnimationColourToMatchTheme,
  setStandardAnimationColourToMatchTheme,
};
